import DocumentLayout from "../../../../src/layouts/Document";
import * as React from 'react';
export default {
  DocumentLayout,
  React
};